import React from 'react'

import AddCustomFieldItem from "./item"

type Props = {
    name        : string
    items       : any[]

    onSelectType: {(id:string):void}
}

export default function AddCustomFieldGroup(props:Props) {
    return (
        <div className="fields-group">
            <div className="group-name">
                <div className="ui5-title-small">{props.name}</div>
                <div className="h-separator m-t-10"/>
            </div>
            <div className="items">
                {_.map(props.items, item=><AddCustomFieldItem key={item.id} data={item} onClick={props.onSelectType}/>)}
            </div>
        </div>
    );
}